import React from 'react';
import { formatValue } from './DataTableCard';

const TrendSummaryCard = ({ card }) => {
  if (!card || !card.metrics) return null;

  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-4 shadow-sm w-full mt-3">
      {card.title && (
        <div className="text-xs font-semibold text-gray-700 mb-3">{card.title}</div>
      )}
      <div className="space-y-3">
        {card.metrics.map((metric, i) => {
          const current = Number(metric.current || 0);
          const previous = Number(metric.previous || 0);
          const changePct = previous !== 0
            ? ((current - previous) / previous) * 100
            : 0;
          const isPositive = changePct >= 0;

          return (
            <div key={i} className="flex items-center justify-between">
              <div>
                <div className="text-[10px] text-gray-400">{metric.label}</div>
                <div className="text-sm font-bold">
                  {formatValue(current, metric.format, metric.label)}
                </div>
              </div>
              <div className="flex items-center gap-2">
                <span
                  className={`inline-flex items-center px-1.5 py-0.5 rounded-full text-[10px] font-medium ${
                    isPositive
                      ? 'bg-green-50 text-green-700'
                      : 'bg-red-50 text-red-700'
                  }`}
                >
                  {isPositive ? '\u2191' : '\u2193'}
                  {Math.abs(changePct).toFixed(1)}%
                </span>
                <span className="text-[10px] text-gray-400">
                  prev: {formatValue(previous, metric.format, metric.label)}
                </span>
              </div>
            </div>
          );
        })}
      </div>
      {card.period && (
        <div className="mt-4 text-[10px] text-gray-400 text-right font-mono">
          {card.period.start} &rarr; {card.period.end}
        </div>
      )}
    </div>
  );
};

export default TrendSummaryCard;
